<template>
  <div id="rightID">
    <div class="right-index">
      <div class="top-right">
        <div class="icon05"></div>
        <div class="right-weather" v-if="weatherDto.areaName">
          <div class="weather-icon">
            <i
              class="weather--menu-icon sun"
              v-if="weatherDto.weather === '晴'"
            ></i>
            <i
              class="weather--menu-icon cloudy"
              v-if="weatherDto.weather === '多云'"
            ></i>
            <i
              class="weather--menu-icon overcast"
              v-if="weatherDto.weather === '阴'"
            ></i>
            <i
              class="weather--menu-icon rain"
              v-if="weatherDto.weather == '雨' || weatherDto.weather === '小雨'"
            ></i>
            <i
              class="weather--menu-icon snow"
              v-if="weatherDto.weather === '霾'"
            ></i>
          </div>
          <div>{{ weatherDto.temperature }}°C</div>
          <div>{{ weatherDto.weather }}</div>
          <div>
            湿度:<span> {{ weatherDto.humidity }}% </span>
          </div>
          <div>{{ weatherDto.areaName }}</div>
        </div>
      </div>
      <div class="right-content">
        <div class="statistics float-left">
          <div class="bg-statistics">
            <div @click="getRightShow('maintainPage')">
              <div class="text-title">
                <div class="text">
                  <div class="spot"></div>
                  保养统计
                </div>
              </div>
              <div class="progress">
                <div class="bg-circle2"></div>
                <div class="progress-text">
                  {{ maintainData.finishRateDto.finishRate || 0 }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="statistics-text">
              <div
                class="float-left complete"
                @click="getRightShow('maintainPage', 'success')"
              >
                <div class="complete-equ">
                  {{ maintainData.finishRateDto.finishNum }}次
                </div>
                <div class="text14-color">已完成</div>
              </div>
              <div
                class="float-left unfinished"
                @click="getRightShow('maintainPage', 'unsuccessful')"
              >
                <div class="unfinished-equ">
                  {{ maintainData.finishRateDto.unfinished }}次
                </div>
                <div class="text14-color">未完成</div>
              </div>
            </div>
          </div>
          <div class="bg-statistics">
            <div @click="getRightShow('inspectPage')">
              <div class="text-title">
                <div class="text">
                  <div class="spot"></div>
                  巡检统计
                </div>
                
              </div>
              <div class="progress">
                <div class="bg-circle"></div>
                <div class="progress-text">
                  {{ inspectData.finishRateDto.finishRate || 0 }}<span>%</span>
                </div>
              </div>
            </div>
            <div class="statistics-text">
              <div
                class="float-left complete"
                @click="getRightShow('inspectPage', 'success')"
              >
                <div class="complete-equ">
                  {{ inspectData.finishRateDto.finishNum }}次
                </div>
                <div class="text14-color">已完成</div>
              </div>
              <div
                class="float-left unfinished"
                @click="getRightShow('inspectPage', 'unsuccessful')"
              >
                <div class="unfinished-equ">
                  {{ inspectData.finishRateDto.unfinished }}次
                </div>
                <div class="text14-color">未完成</div>
              </div>
            </div>
          </div>
          <div class="bg-statistics">
            <div @click="getRightShow('meteringPage')">
              <div class="text-title">
                <div class="spot"></div>
                <div class="text">计量类型</div>
              </div>
              <!-- <div class="m-public Mprogress">
              <el-progress
                type="circle"
                :stroke-width="12"
                :width="120"
                :percentage="Number(meteringTypeDto.imperativeRate)"
                color="#02D9FD"
                stroke-linecap="butt"
                :format="formatText"
                class="Mprogress1"
              ></el-progress>
            </div> -->
              <div class="metering-type" id="meteringPieChart"></div>
            </div>
            <div class="statistics-text">
              <div
                class="float-left complete"
                @click="getRightShow('meteringPage-imperative', 'imperative')"
              >
                <div class="complete-equ">{{ meteringPieData[0].value }}台</div>
                <div class="text14-color">强检设备</div>
              </div>
              <div
                class="float-left unfinished"
                @click="
                  getRightShow('meteringPage-non_imperative', 'non_imperative')
                "
              >
                <div class="unfinished-equ">
                  {{ meteringPieData[1].value }}台
                </div>
                <div class="text14-color">非强检</div>
              </div>
            </div>
          </div>
        </div>

        <div class="float-left right-echarts">
          <!-- 折线图 -->
          <div class="maintain-statistics">
            <div class="text-title">
              <div class="spot"></div>
              <div class="text">平台保养巡检统计</div>
            </div>
            <div
              class="maintain-wiring-diagram"
              id="maintainWiringDiagram"
            ></div>
          </div>
          <!-- 滚动排行 -->
          <div class="engineer-ranking">
            <div class="text-title">
              <div class="spot"></div>
              <div class="text">工程师工作排行</div>
            </div>
            <div style="">
              <div class="ranking-type">
                <span class="typeW1">排名</span>
                <span class="typeW2">所属医院</span>
                <span class="typeW3">工程师</span>
                <span class="typeW4">维修</span>
                <span class="typeW5">保养</span>
                <span class="typeW6">巡检</span>
              </div>
            </div>
            <div>
              <seamless
                v-if="engineerRankingDtoList && engineerRankingDtoList.length"
                :listData="engineerRankingDtoList" @Ranking="Ranking"
              ></seamless>
            </div>
          </div>
          <!-- 设备价值饼图 -->
          <div class="equ-value">
            <div class="text-title" @click="getRightShow('equPageValue')">
              <div class="spot"></div>
              <div class="text">设备价值</div>
            </div>
            <div class="pie-chart" id="pieChart"></div>
            <div class="numb-equ">
              <div
                class="numb-equ-item"
                v-for="(item, index) in equPieData"
                :key="index"
                @click="getRightShow('equPageValue', item.purchaseMoneySearch)"
              >
                {{ item.value*9 }}
                <span class="numb-equ-item-spam">台</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util.js'
import seamless from '@/components/seamless'
// import circularProgressBar from "@/components/circular-progress-bar";
import { SocketInit } from '@/utils/websocket/socketUtil.js'
import allStatus from '@/utils/all-status.js'
export default {
  mixins: [SocketInit], // 混入文件
  components: {
    seamless
  },
  data () {
    return {
      util,
      allStatus,
      animateUp: false,
      timeRanking: null,
      chartInstance: null,
      pieChartInstance: null,
      percentage: 10,
      xDataArr: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
      ],
      dayXDataArr: [
        '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22'
      ],
      // 保养信息
      maintainData: {
        finishRateDto: {
          finishNum: 0,
          finishRate: 0,
          unfinished: 0
        },
        name: '',
        statisticsDtoList: []
      },
      // 巡检信息
      inspectData: {
        finishRateDto: {
          finishNum: 0,
          finishRate: 0,
          unfinished: 0
        },
        name: '',
        statisticsInspectDtoList: []
      },
      //  设备饼图
      equPieData: [
        {
          value: '0',
          name: '1万以下',
          purchaseMoneySearch: 'one',
          itemStyle: { color: '#025FFF' }
        },
        {
          value: '0',
          name: '1万至5万',
          purchaseMoneySearch: 'two',
          itemStyle: { color: '#00FFCB' }
        },
        {
          value: '0',
          name: '5万至10万',
          purchaseMoneySearch: 'three',
          itemStyle: { color: '#FF7A30' }
        },
        {
          value: '0',
          name: '10万至50万',
          purchaseMoneySearch: 'four',
          itemStyle: { color: '#41C476' }
        },
        {
          value: '0',
          name: '50万以上',
          purchaseMoneySearch: 'five',
          itemStyle: { color: '#FFCD5E' }
        }
      ],
      // 统计  工作排行
      engineerRankingDtoList: [],
      // 天气
      weatherDto: {
        areaId: '',
        areaName: '',
        humidity: '',
        isDelete: false,
        temperature: '',
        weather: '',
        weatherId: '',
        windDirection: '',
        windPower: ''
      },
      // 计量类型
      meteringPieChartData: null,
      meteringPieData: [
        { value: '0', name: '强检设备', itemStyle: { color: '#00FFFF' } },
        { value: '0', name: '非强检', itemStyle: { color: '#FF7A30' } }
      ],
      typeName: null, // 全部都更改的标题名称,
      dateType: null, // 时间类型(判定拆线图要是月，日)
      monthDateListName_X: []// x轴显示日
    }
  },
  mounted () {
    // 取当前年的开始/结束时间
    let currentYear = new Date()
    let startYear = this.util.startYear(currentYear)
    let endYear = this.util.endYear(currentYear)
    this.lineSearchParam.startTime = startYear
    this.lineSearchParam.endTime = endYear
    //   折线图
    this.initChart()
    // 饼图
    this.getPieChart()
    this.getPieChartData()

    // 计量饼图
    this.getmeteringPieChart()
    this.initSocket(this.$Pane.rightPane.id) // 测试
    // this.initSocket("center-098"); // 线上
  },
  beforeMount () {
    // this.updateChart()
  },
  destroyed () {
    // clearInterval(this.timeRanking);
  },
  methods: {
    // 接收共享信息
    acceptSharingData (info) {
      console.log('接收左屏共享信息', info)
      let message = JSON.parse(info.webSocketShareDto.message)
      console.log(message)
      if (message.type === 'updateTips') {
        if (message.typeName) {
          this.typeName = message.typeName
          this.dateType = message.dateType
        }
      }
    },
    // 工程师详情
    Ranking (e) {
      console.log('工程师详情', e)
      this.getRightShow(e.type, e.hospitalId)
    },
    // 查看各数据详情
    getRightShow (type, status = null) {
      let message = {
        type: type,
        status: status
      }
      this.shareInformation(message, this.$Pane.rightPane.send) // 发起共享信息,共享信息客户端的二级ID  测试
    },

    acceptInspectData (data) {
      console.log('巡检信息----------', data)
      if (data) {
        if (
          data.statisticsInspectDtoList &&
          data.statisticsInspectDtoList.length
        ) {
          this.inspectData.statisticsInspectDtoList = data.statisticsInspectDtoList
          this.inspectData.name = '巡检工单'
          this.xDataArr = this.inspectData.statisticsInspectDtoList.map(item => item.name)

          this.updateChart()
        }
        if (data.finishRateDto) {
          this.inspectData.finishRateDto.finishRate = Number(
            data.finishRateDto.finishRate
          )
          this.inspectData.finishRateDto.finishNum =
            data.finishRateDto.finishNum
          this.inspectData.finishRateDto.unfinished =
            data.finishRateDto.unfinished
        }
      }
    },
    acceptWeatherData (data) {
      console.log('天气信息----------', data)
      if (data && data.weatherDto) {
        this.weatherDto = data.weatherDto
      }
    },
    acceptMaintainData (data) {
      console.log('保养信息----------', data)
      if (data) {
        if (data.statisticsDtoList && data.statisticsDtoList.length) {
          this.maintainData.statisticsDtoList = data.statisticsDtoList
          this.xDataArr = this.inspectData.statisticsInspectDtoList.map(item => item.name)
          this.maintainData.name = '保养工单'
          this.updateChart()
        }
        if (data.finishRateDto) {
          this.maintainData.finishRateDto.finishRate = Number(
            data.finishRateDto.finishRate
          )
          this.maintainData.finishRateDto.finishNum =
            data.finishRateDto.finishNum
          this.maintainData.finishRateDto.unfinished =
            data.finishRateDto.unfinished
        }
      }
    },
    acceptEquData (data) {
      console.log('设备信息----------', data)
      if (data) {
        if (data.equPurchaseMoneyTotalDTO) {
          let equdata = data.equPurchaseMoneyTotalDTO
          this.equPieData.forEach((item) => {
            if (item.name === '1万以下') {
              item.value = equdata.oneLevelTotal
            }
            if (item.name === '1万至5万') {
              item.value = equdata.twoLevelTotal
            }
            if (item.name === '5万至10万') {
              item.value = equdata.threeLevelTotal
            }
            if (item.name === '10万至50万') {
              item.value = equdata.fourLevelTotal
            }
            if (item.name === '50万以上') {
              item.value = equdata.fiveLevelTotal
            }
          })
          this.getPieChartData()
        }
      }
    },
    acceptStatisticsData (data) {
      console.log('统计信息----------', data)
      if (
        data &&
        data.engineerRankingDtoList &&
        data.engineerRankingDtoList.length
      ) {
        this.engineerRankingDtoList = []
       this.engineerRankingDtoList = data.engineerRankingDtoList.filter(_f=>{
          if( _f.repairNum || _f.maintainNum || _f.inspectNum ){
             return _f
          }
        })
      }
      if (data.meteringTypeDto) {
        this.meteringTypeDto = data.meteringTypeDto
        this.meteringPieData.forEach((item) => {
          if (item.name === '强检设备') {
            item.value = data.meteringTypeDto.imperativeNum
          }
          if (item.name === '非强检') {
            item.value = data.meteringTypeDto.nonImperativeNum
          }
        })

        this.getmeteringPieChartData()
      }
    },
    //   折线图初始化echarts实例
    initChart () {
      let _this = this
      this.chartInstance = this.$echarts.init(
        document.getElementById('maintainWiringDiagram')
      )
      this.chartInstance.on('click', function (params) {
        console.log('折线图点击事', params)
        if (params.seriesName === '巡检工单') {
          console.log('点击巡检')
          let data = {
            type: 'equInspectPage',
            month: ''
          }
          if (_this.dateType === 'day') {
            data.date = params.name
          } else {
            // 组装年月
            data.date = _this.searchParam.year + '-' + _this.allStatus.dateMonth(params.name)
          }
          _this.getRightShow(data)
        }
        if (params.seriesName === '保养工单') {
          console.log('点击保养')

          let data = {
            type: 'equMaintainPage',
            month: ''
          }
          if (_this.dateType === 'day') {
            data.date = params.name
          } else {
            // 组装年月
            data.date = _this.searchParam.year + '-' + _this.allStatus.dateMonth(params.name)
          }
          _this.getRightShow(data)
        }
      })
      const maintainOption = {
        grid: {
          // 整体调位置
          top: 38,
          left: 0,
          right: '4%',
          bottom: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          // type: "time",
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#7292D8',
            fontSize: 10
          },
          axisLine: {
            show: true // 是否显示坐标轴轴线。
          }
        },
        yAxis: {
          type: 'value',
          scale: true, // 脱离0值比例
          axisLabel: {
            color: '#7292D8',
            fontSize: 10
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: ['#112553'],
              width: 0.8,
              type: 'solid'
            }
          }
        }
      }

      this.chartInstance.setOption(maintainOption)
    },
    //   折线图处理图表数据
    updateChart () {
      const dataOption = {
        // dayXDataArr
        // xDataArr
        xAxis: {
          data: this.xDataArr
        },
        legend: {
          itemWidth: 12,
          itemHeight: 8,
          icon: 'rect',
          right: '1%',
          top: 10,
          textStyle: {
            color: '#ffffff'
          }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            // symbol: 'none',

            name: this.inspectData.name,
            type: 'line',
            // arr_arr
            // this.inspectData.statisticsInspectDtoList
            data: this.inspectData.statisticsInspectDtoList,
            smooth: true,
            showSymbol: false,
            stack: 'all',
            lineStyle: {
              color: '#D08131'
            },
            itemStyle: {
              color: 'rgba(255, 149, 42, 1)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(255, 149, 42, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(255, 149, 42, 0)'
                }
              ])
            }
          },
          {
            name: this.maintainData.name,
            type: 'line',
            data: this.maintainData.statisticsDtoList,
            smooth: true,
            showSymbol: false,
            stack: 'all',
            lineStyle: {
              color: '#179BCF'
            },
            itemStyle: {
              color: 'rgba(26, 173, 229, 1)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(26, 173, 229, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(26, 173, 229, 0)'
                }
              ])
            }
          }
        ]
      }
      this.chartInstance.setOption(dataOption)
    },
    getPieChart () {
      // 设备价值饼图初始化echarts实例
      this.pieChartInstance = this.$echarts.init(
        document.getElementById('pieChart')
      )
      const pieChart = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 100,
          top: 20,
          bottom: 20,
          icon: 'circle',
          itemGap: 17,
          textStyle: {
            color: '#7292D8',
            fontSize: 14
          }
          // data: data.legendData
        },
        series: [
          // {
          //   type: 'pie',
          //   radius: ['30%', '70%'],
          //   center: [90, '50%'],
          //   roseType: 'radius',
          //   itemStyle: {
          //     // borderRadius: 5,
          //   },
          //   label: {
          //     show: false
          //   }
          // }
          {
            type: 'pie',
            radius: ['30%', '70%'],
            center: [90, '50%'],
            // avoidLabelOverlap: false,
            label: {
              show: false,
              // position: 'center'
            },
            // labelLine: {
            //   show: false
            // }
          }
        ]
      }
      this.pieChartInstance.setOption(pieChart)
    },
    getPieChartData () {
      // 设备价值饼图处理图表数据
      const pieChartData = {
        series: [
          {
            data: this.equPieData
          }
        ]
      }
      this.pieChartInstance.setOption(pieChartData)
    },

    getmeteringPieChart () {
      // 计量饼图饼图初始化echarts实例
      this.meteringPieChartData = this.$echarts.init(
        document.getElementById('meteringPieChart')
      )
      const meteringData = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '90%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            }
          }
        ]
      }
      this.meteringPieChartData.setOption(meteringData)
    },
    getmeteringPieChartData () {
      // 计量饼图处理图表数据
      const meteringTypeData = {
        series: [
          {
            data: this.meteringPieData
          }
        ]
      }
      this.meteringPieChartData.setOption(meteringTypeData)
    },
    // 进度条提示字
    formatText (value) {
      return `${value}`
    }
  }
}
</script>

<style scoped>
@import "../style/common.css";
#rightID {
  background-color: #000;
}
.right-index {
  width: 640px;
  height: 1080px;
  box-sizing: border-box;
  background-image: url("../assets/bg11.png");
  background-repeat: no-repeat;
}
.top-right {
  width: 640px;
  height: 96px;
  position: relative;
}
.icon05 {
  width: 486px;
  height: 16px;
  background-image: url("../assets/icon-05.png");
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
}
.right-weather {
  width: 482px;
  height: 96px;
  background-image: url("../assets/right-weather.png");
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 140px;
  text-align: center;
}
.weather--menu-icon {
  margin-left: 10px;
  display: inline-block;
  width: 32px;
  height: 32px;
}
.weather-icon {
  position: absolute;
  top: 8px;
  left: 40px;
}
.sun {
  background: url(../assets/sun.png) center no-repeat;
  background-size: cover;
}

.cloudy {
  background: url(../assets/cloudy.png) center no-repeat;
  background-size: cover;
}

.overcast {
  background: url(../assets/overcast.png) center no-repeat;
  background-size: cover;
}

.rain {
  background: url(../assets/rain.png) center no-repeat;
  background-size: cover;
}

.snow {
  background: url(../assets/snow.png) center no-repeat;
  background-size: cover;
}
.right-weather > div {
  font-size: 20px;
  color: #a2c6f9;
  margin-left: 15px;
  height: 96px;
  display: inline-block;
}
/* 内容 */
.right-content {
  width: 640px;
  height: 984px;
  padding: 20px 20px 0 0;
  box-sizing: border-box;
}
/* 统计 */
.statistics {
  width: 175px;
  height: 964px;
}
.bg-statistics {
  width: 174px;
  height: 298px;
  box-sizing: border-box;
  background-image: url("../assets/bg06.png");
  background-repeat: no-repeat;
  margin-bottom: 22px;
  padding: 20px 10px;
}
.progress {
  position: relative;
  width: 154px;
  height: 146px;
  position: relative;
  text-align: center;
  margin-top: 24px;
}
.bg-circle2 {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 146px;
  height: 146px;
  background-image: url("../assets/bg-circle2.png");
  background-repeat: no-repeat;
  animation: bgCircle2 6s infinite linear;
}
.bg-circle {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 146px;
  height: 146px;
  background-image: url("../assets/bg-circle.png");
  background-repeat: no-repeat;
  animation: bgCircle 6.5s infinite linear;
}

.progress-text {
  font-size: 28px;
  height: 146px;
  line-height: 146px;
  color: #ffffff;
}
.progress-text span {
  font-size: 18px;
}
.statistics-text {
  width: 154px;
  margin-top: 20px;
  height: 50px;
}
.complete {
  width: 75px;
  text-align: center;
}
.complete-equ {
  color: #00ffff;
  margin-bottom: 5px;
}
.unfinished {
  width: 75px;
  text-align: center;
}
.unfinished-equ {
  color: #f83b44;
  margin-bottom: 5px;
}
.m-public {
  float: left;
  width: 125px;
  text-align: center;
  height: 135px;
  margin-top: 35px;
}
.metering-type {
  width: 154px;
  height: 150px;
  margin-top: 20px;
}

/* 最右边 */
.right-echarts {
  width: 445px;
  height: 964px;
  padding-left: 15px;
  box-sizing: border-box;
}
/* 平台保养统计 */
.maintain-statistics {
  width: 429px;
  height: 304px;
  box-sizing: border-box;
  background-image: url("../assets/bg08.png");
  background-repeat: no-repeat;
  margin-bottom: 25px;
  padding: 20px 10px;
}
.maintain-wiring-diagram {
  width: 409px;
  height: 255px;
}
/* 工程师排名 */
.engineer-ranking {
  width: 429px;
  height: 344px;
  box-sizing: border-box;
  background-image: url("../assets/bg07.png");
  background-repeat: no-repeat;
  padding: 20px 15px;
  overflow: hidden;
}
.ranking-type {
  width: 399px;
  height: 30px;
  background: #072152;
  border: 1px solid #254b92;
  border-radius: 4px;
  color: #a2c6f9;
  font-size: 14px;
  line-height: 30px;
  margin-top: 18px;
  padding: 0 5px 0 14px;
  box-sizing: border-box;
  margin-bottom: 15px;
}
.ranking-type > span {
  display: inline-block;
  /* text-align: center; */
}
.typeW1 {
  width: 35px;
}
.typeW2 {
  width: 80px;
  margin-left: 5px;
}
.typeW3 {
  width: 60px;
}
.typeW4 {
  width: 60px;
}
.typeW5 {
  width: 60px;
}
.typeW6 {
  width: 55px;
  padding-left: 5px;
  box-sizing: border-box;
}
/* 饼图 */
.equ-value {
  width: 429px;
  height: 244px;
  box-sizing: border-box;
  background-image: url("../assets/bg04.png");
  background-repeat: no-repeat;
  padding: 20px 15px;
  margin-top: 24px;
  box-sizing: border-box;
  position: relative;
}
.pie-chart {
  width: 399px;
  height: 204px;
}
.numb-equ {
  width: 105px;
  height: 174px;
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 20px;
  box-sizing: border-box;
  padding-top: 8px;
}
.numb-equ-item {
  color: #0bdfe1;
  margin-bottom: 10px;
  font-size: 16px;
}
.numb-equ-item-spam {
  color: #7292d8;
  font-size: 14px;
}
@keyframes bgCircle2 {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
@keyframes bgCircle {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/right_index.vue